import { render } from "./CenteredText.vue?vue&type=template&id=ba339bd2"
import script from "./CenteredText.vue?vue&type=script&lang=js"
export * from "./CenteredText.vue?vue&type=script&lang=js"
script.render = render

export default script